

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import styles from './Modal.css';
import withStyles from '../../decorators/withStyles';


class Modal extends Component {

  static propTypes = {
    error: PropTypes.object,
    title: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    returnTo: PropTypes.string,
    containerClass: PropTypes.string
  };

  static defaultProps = {
    isOpen: false,
    containerClass: ""
  };

  ignoreClick = (e) => {
    e.stopPropagation();
  };


  setBodyScrollState() {
    if (this.props.modalVisible || this.props.isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style['overflow-y'] = "scroll";
      document.body.style['overflow-x'] = "hidden";
    }
  }

  componentDidMount() {
    this.setBodyScrollState();
  }

  componentDidUpdate(props) {
    this.setBodyScrollState();
  }

  render() {
    if (this.props.isOpen) {
      return (
        <div className="Modal background" onClick={this.props.handleClick}>
          <div className={`container`} onClick={this.ignoreClick}>
            <div className="modal-header">
              <h1>{this.props.title || this.props.modalTitle}</h1>
              <span className="modal-x" onClick={this.props.handleClick}>×</span>
              <hr />
            </div>
            <div className="content">
              {this.props.children}
            </div>
          </div>
        </div>
      )
    } else {
      return <div></div>
    }

  }

}

export default compose(
  withStyles(styles),
  connect((state) => {return {modalVisible: state.modalVisible,
                            modalTitle: state.modalTitle,
                            downloadFormID: state.downloadFormID};}),
)(Modal);
